export default "__VITE_ASSET__BmygzjSH__"